// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 11 hooks for backend/cashRepairs.

import { useBackend } from '../useBackend'

/** POST /api/cashRepairs/approveCashRepair */
export function useApproveCashRepair<T = any>() {
  return useBackend<T>('cashRepairs/approveCashRepair')
}

/** POST /api/cashRepairs/cancelCashRepair */
export function useCancelCashRepair<T = any>() {
  return useBackend<T>('cashRepairs/cancelCashRepair')
}

/** POST /api/cashRepairs/confirmCashRepairSlip */
export function useConfirmCashRepairSlip<T = any>() {
  return useBackend<T>('cashRepairs/confirmCashRepairSlip')
}

/** POST /api/cashRepairs/declineCashRepair */
export function useDeclineCashRepair<T = any>() {
  return useBackend<T>('cashRepairs/declineCashRepair')
}

/** POST /api/cashRepairs/getCashRepairOptions */
export function useGetCashRepairOptions<T = any>() {
  return useBackend<T>('cashRepairs/getCashRepairOptions')
}

/** POST /api/cashRepairs/getCashRepairs */
export function useGetCashRepairs<T = any>() {
  return useBackend<T>('cashRepairs/getCashRepairs')
}

/** POST /api/cashRepairs/getCashRepairsAccess */
export function useGetCashRepairsAccess<T = any>() {
  return useBackend<T>('cashRepairs/getCashRepairsAccess')
}

/** POST /api/cashRepairs/markCashRepairPaid */
export function useMarkCashRepairPaid<T = any>() {
  return useBackend<T>('cashRepairs/markCashRepairPaid')
}

/** POST /api/cashRepairs/raiseCashRepair */
export function useRaiseCashRepair<T = any>() {
  return useBackend<T>('cashRepairs/raiseCashRepair')
}

/** POST /api/cashRepairs/uploadCashRepairQuote */
export function useUploadCashRepairQuote<T = any>() {
  return useBackend<T>('cashRepairs/uploadCashRepairQuote')
}

/** POST /api/cashRepairs/uploadCashRepairReceipt */
export function useUploadCashRepairReceipt<T = any>() {
  return useBackend<T>('cashRepairs/uploadCashRepairReceipt')
}
